'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var classNames = require('classnames');
var accordion = require('@andes-headless/accordion');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var ChevronDown20 = require('@andes/icons/ChevronDown20');
var useTransition = require('@andes/common/build/hooks/useTransition');
var common = require('@andes/common');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var ChevronDown20__default = /*#__PURE__*/_interopDefaultLegacy(ChevronDown20);
const namespace = 'andes-accordion';
const namespaceAccordionHeader = 'andes-accordion-header';
const namespaceAccordionPanel = 'andes-accordion-panel';
const SMALL = 'small';
const MEDIUM = 'medium';
const LARGE = 'large';
const SIZES = {
  SMALL,
  MEDIUM,
  LARGE
};
var _ChevronDown;
const _excluded = ["description", "indicatorConfig", "expanded", "title", "titleMaxLines", "id"];
const getLimitedLinesStyles = titleMaxLines => {
  if (!titleMaxLines) {
    return {};
  }
  return {
    lineClamp: titleMaxLines,
    WebkitLineClamp: titleMaxLines
  };
};
const AccordionHeader = /*#__PURE__*/function () {
  const AccordionHeader = _ref => {
    var _indicatorConfig$show;
    let {
        description,
        indicatorConfig,
        expanded,
        title,
        titleMaxLines,
        id
      } = _ref,
      rest = _objectWithoutProperties__default["default"](_ref, _excluded);
    const accordionTitleClasses = classNames__default["default"]("".concat(namespaceAccordionHeader, "-container__title"), titleMaxLines && "".concat(namespaceAccordionHeader, "-container__title--limited-lines"));
    const accordionDescriptionClasses = "".concat(namespaceAccordionHeader, "-container__description");
    const showIcon = (_indicatorConfig$show = indicatorConfig === null || indicatorConfig === void 0 ? void 0 : indicatorConfig.showIcon) !== null && _indicatorConfig$show !== void 0 ? _indicatorConfig$show : true;
    return /*#__PURE__*/React__default["default"].createElement("button", _extends__default["default"]({
      type: "button",
      className: namespaceAccordionHeader,
      "aria-expanded": expanded,
      "aria-controls": "".concat(id, "-accordion-content"),
      id: "".concat(id, "-accordion-header")
    }, rest), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespaceAccordionHeader, "-container")
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespaceAccordionHeader, "-container__content")
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: accordionTitleClasses,
      style: getLimitedLinesStyles(titleMaxLines)
    }, void 0, typeof title === 'function' ? null : title), typeof title === 'function' || !description ? null : /*#__PURE__*/_jsx__default["default"]("div", {
      className: accordionDescriptionClasses
    }, void 0, description)), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespaceAccordionHeader, "-container__indicator")
    }, void 0, expanded ? indicatorConfig === null || indicatorConfig === void 0 ? void 0 : indicatorConfig.expandedLabel : indicatorConfig === null || indicatorConfig === void 0 ? void 0 : indicatorConfig.collapsedLabel, showIcon ? _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx__default["default"](ChevronDown20__default["default"], {
      color: "rgba(0, 0, 0, 0.55)"
    })) : null)));
  };
  AccordionHeader.displayName = 'AccordionHeader';
  return AccordionHeader;
}();
var AccordionHeader$1 = AccordionHeader;
const Accordion = /*#__PURE__*/function () {
  const Accordion = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      children,
      className,
      defaultExpanded,
      description: descriptionContent,
      disabled,
      expanded,
      indicator = {},
      extend = false,
      id,
      onChange,
      size = SIZES.MEDIUM,
      showDivider = true,
      title,
      titleMaxLines
    } = _ref;
    const [{
      status
    }, toggle] = useTransition.useTransition({
      timeout: 300,
      preEnter: true,
      initialEntered: expanded || defaultExpanded
    });
    React.useEffect(() => {
      if (typeof expanded === 'boolean') {
        toggle(expanded);
      }
    }, [expanded]);
    const accordionContainerClasses = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--").concat(size)]: size,
      ["".concat(namespace, "--without-divider")]: !showDivider
    });
    const handleChange = (event, isExpanded) => {
      if (typeof expanded === 'undefined') {
        toggle(isExpanded);
      }
      if (typeof onChange === 'function') onChange(event, isExpanded);
    };
    return /*#__PURE__*/React__default["default"].createElement(accordion.Accordion, {
      className: accordionContainerClasses,
      ref: ref,
      id: id,
      disabled: disabled,
      defaultExpanded: defaultExpanded,
      expanded: expanded,
      onChange: handleChange
    }, /*#__PURE__*/_jsx__default["default"](accordion.AccordionHeader, {}, void 0, extend && typeof title === 'function' ? title : _ref2 => {
      let {
        id: headerId,
        expanded: isHeaderExpanded,
        componentGetterProps: {
          getHeaderProps,
          getHeadlessAttributes
        }
      } = _ref2;
      return /*#__PURE__*/React__default["default"].createElement(AccordionHeader$1, _extends__default["default"]({
        id: headerId,
        title: title,
        titleMaxLines: titleMaxLines,
        expanded: isHeaderExpanded,
        indicatorConfig: indicator
      }, size === SIZES.SMALL ? {} : {
        description: descriptionContent
      }, getHeaderProps(), getHeadlessAttributes()));
    }), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespaceAccordionPanel, "-transition"),
      "data-andes-transition-status": status
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespaceAccordionPanel, "-transition__inner")
    }, void 0, /*#__PURE__*/_jsx__default["default"](accordion.AccordionPanel, {}, void 0, children))));
  });
  Accordion.displayName = 'Accordion';
  return Accordion;
}();
var Accordion$1 = common.withTracker(Accordion);
exports.Accordion = Accordion$1;
